import QuestionsForm, { QUESTIONS_FORM_ID } from './QuestionsForm.vue'

export { QUESTIONS_FORM_ID }
export default QuestionsForm
